import React, { useState, useEffect } from 'react';
import { BarItemMolecule } from '../../molecules';
import { NavigationBarProps } from './navigation-bar.props';
import { useNavigationBarStyles } from '../../../styles/organisms/navigation-bar.styles';
import { CSSTransition } from 'react-transition-group';
import useScrollPosition from '@react-hook/window-scroll';
import { useSelector } from 'react-redux';
import { StoreState, useLogoutCustomerEffect } from '../../../services';
import { Route, loginLogoutLinks } from '../../../enums';
import { useRouter } from 'next/router';

export const NavigationBarOrganism = (props: NavigationBarProps) => {
  const classes = useNavigationBarStyles();
  const [navBarOpened, setNavbarOpened] = useState(true);
  const router = useRouter();
  const { logoutCustomer } = useLogoutCustomerEffect();

  const scrollY = useScrollPosition(60);
  useEffect(() => {
    if (scrollY > 200) {
      setNavbarOpened(false);
    } else {
      setNavbarOpened(true);
    }
  }, [scrollY]);
  const {
    customer: { authedId, loggedIn },
  } = useSelector((state: StoreState) => {
    return {
      customer: state.customers.customer,
    };
  });

  return (
    <>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        timeout={250}
        appear
        in={navBarOpened}
        classNames="navigationBar-transition"
      >
        <section
          data-cy="navigation-bar"
          id="product-nav"
          className={`text-center overflow-x-autox -ml-10  hidden lg:block ${classes['navigationBar-transition']}`}
        >
          <ul className="flex justify-start lg:justify-center sm:justify-start w-full left-0 list-none my-2 lg:my-2.5">
            {props.productLinks.map((headerLink, index) => (
              <BarItemMolecule key={index} {...headerLink} />
            ))}
            {/* HIDE TEMPORARILY AS PER DAVID 25/2/22 ////
            <li className="uppercase font-medium mx-2 menu-link pl-5">
              {(!loggedIn || !authedId) && (
                <a
                  aria-label="Login To Your Account"
                  className="text-footer text-waldo-blue"
                  onClick={() => router.push(Route.MEMBER_LOGIN)}
                >
                  {loginLogoutLinks.LOGIN}
                </a>
              )}
              {(loggedIn || authedId) && (
                <a
                  aria-label="Log out of Your Account"
                  className="text-footer text-waldo-blue"
                  onClick={() => logoutCustomer()}
                >
                  {loginLogoutLinks.LOGOUT}
                </a>
              )}
            </li>*/}
          </ul>
        </section>
      </CSSTransition>
    </>
  );
};
